import { Card, Grid, Typography } from '@mui/material';
import { BakeasyButtonIconBack } from '../buttons/BakeasyButtons';

export interface BakeasyAppBarProps {
  title?: any;
  clickable?: boolean;
  icon?: any;
  menus?: any;
  onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function BakeasyAppBar(props: BakeasyAppBarProps) {
  return (
    <Card>
      <Grid
        container
        spacing={1}
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 1 }}
      >
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <Grid container sx={{ alignItems: 'center', justifyContent: 'start' }}>
            <BakeasyButtonIconBack onClick={props?.onBackClick} />
            <Typography>{props?.title}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          {props?.menus && (
            <Grid container sx={{ alignItems: 'center', justifyContent: 'end' }}>
              {props?.menus}
            </Grid>
          )}
        </Grid>
      </Grid>
      {/* <Grid container>
        <Grid item sx={{ padding: 1 }}>
          <BackIcon onClick={props?.onBackClick} />
        </Grid>
        <Grid item sx={{ alignItems: 'center', display: 'flex' }}>
          <Typography> {props?.title}</Typography>
        </Grid>
      </Grid>
      {props?.menus && (
        <Grid container sx={{ alignItems: 'center', justifyContent: 'end', marginRight: 1 }}>
          {props?.menus}
        </Grid>
      )} */}
    </Card>
  );
}
